<template>
  <div class="overflow-y-scroll w-full h-full pb-5">
    <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 mt-10">
      <div class="mb-6">
        <router-link
          :to="{ name: 'ExperProfieletList', }"
          class="inline-flex items-center gap-1 text-sm text-blue hover:underline"
        >
          ← Назад
        </router-link>
      </div>

      <div v-if="!content" class="text-center text-gray-500">Загрузка...</div>

      <div v-else>
        <h1 class="text-3xl font-bold mb-2">{{ content.fio || content.user?.fio || content.title }}</h1>

        <div v-if="content.is_pilot" class="flex flex-wrap items-center gap-2 mb-4">
          <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-0.5 rounded">Пилот</span>
          <span v-if="content.pilot_category" class="bg-blue-50 text-blue-700 text-xs font-semibold px-2 py-0.5 rounded">
            {{ pilotCategoryLabel }}
          </span>
        </div>

        <div v-if="content.is_pilot && pilotServiceLabels.length" class="mb-4">
          <p class="text-sm font-medium text-gray-900 mb-1">Виды услуг пилота</p>
          <div class="flex flex-wrap gap-1">
            <span
              v-for="label in pilotServiceLabels"
              :key="label"
              class="bg-blue-50 text-blue-700 text-xs px-2 py-0.5 rounded"
            >{{ label }}</span>
          </div>
        </div>

        <div class="mb-6">
          <img
            v-if="content.photo"
            :src="content.photo"
            alt="Фото"
            class="rounded-md max-h-[400px] w-full object-contain"
          />
        </div>

        <div class="prose max-w-none space-y-6">
          <section v-if="content.specialization">
            <h2 class="text-xl font-semibold">Специализация</h2>
            <p>{{ content.specialization }}</p>
          </section>

          <section v-if="content.education">
            <h2 class="text-xl font-semibold">Образование</h2>
            <p>{{ content.education }}</p>
          </section>

          <section v-if="content.bio">
            <h2 class="text-xl font-semibold">Биография</h2>
            <p>{{ content.bio }}</p>
          </section>

          <section v-if="content.achievements">
            <h2 class="text-xl font-semibold">Достижения</h2>
            <p>{{ content.achievements }}</p>
          </section>

          <section v-if="content.experience">
            <h2 class="text-xl font-semibold">Опыт</h2>
            <p>{{ content.experience }}</p>
          </section>

          <section v-if="content.content">
            <h2 class="text-xl font-semibold">Дополнительно</h2>
            <div v-html="content.content"></div>
          </section>
        </div>

        <CommentsListComponent
          class="mt-5"
          v-if="content.id"
          content-type="expert_profile"
          :object-id="String(content.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { API_EXPERTS, API_PILOT_SERVICES_PUBLIC, HEADERS_TOKEN_JSON } from "@/const/uri";
import axios from "axios";
import CommentsListComponent from "@/components/Comments/CommentsList.vue";

export default {
  name: "PageContentDetailExperts",
  components: {
    CommentsListComponent,
  },
  data() {
    return {
      content: null,
      availableServices: [],
    };
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    pilotCategoryLabel() {
      const map = {
        first: 'Первая категория',
        second: 'Вторая категория',
        third: 'Третья категория',
        fourth: 'Четвёртая категория',
      };
      return map[this.content?.pilot_category] || this.content?.pilot_category || '';
    },
    pilotServiceLabels() {
      const services = this.content?.pilot_services || [];
      return services
        .map((value) => this.availableServices.find((s) => s.value === value)?.label || value)
        .filter(Boolean);
    },
  },
  mounted() {
    this.fetchPilotServices();
    this.fetchDetail();
  },
  methods: {
    async fetchPilotServices() {
      try {
        const res = await axios.get(API_PILOT_SERVICES_PUBLIC.list, {
          headers: HEADERS_TOKEN_JSON(),
        });
        if (res.data.code === 0) {
          this.availableServices = res.data.data.map(s => ({ value: s.key, label: s.name }));
        }
      } catch (e) {
        console.error("Ошибка загрузки видов услуг:", e);
      }
    },
    async fetchDetail() {
      try {
        const response = await axios.get(
          `${API_EXPERTS.public}${this.slug}/`,
          {
            headers: HEADERS_TOKEN_JSON(),
          }
        );
        if (response.data.code === 0) {
          this.content = response.data.data;
        }
      } catch (error) {
        console.error("Ошибка при загрузке профиля эксперта:", error);
      }
    },
  },
};
</script>
